import { useState, useEffect } from "react";

const DEFAULT_DEBOUNCED_TIME = 500;
export const useDebouncedValue = ({ value }) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, DEFAULT_DEBOUNCED_TIME);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return { debouncedValue };
};
